import Vue from 'vue';
import Router from 'vue-router';

import Form from '@/views/Form.vue';
import Biz from '@/views/Biz.vue';
import NotFound from '@/views/NotFound.vue';
import Landing from '@/views/Landing.vue';
import Check from '@/views/Check.vue';
import { sendPV, customLog, customType } from '@/common/weblog';
import store from '@/store';
import {
    ROUTER_NAME_BIZ,
    ROUTER_NAME_PAGE,
    ROUTER_NAME_CHECK,
} from '@/utils/constant';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/biz/:bizKey',
            name: 'biz',
            props: true,
            component: Biz,
            children: [
                {
                    path: 'page/:pageKey',
                    name: 'page',
                    props: true,
                    component: Form,
                    beforeEnter: (to, from, next) => {
                        if (store.getters.isBooting) {
                            next();
                            return;
                        }

                        next();
                    },
                },
                {
                    path: 'landing',
                    name: 'landing',
                    component: Landing,
                },
                {
                    path: 'check',
                    name: 'check',
                    component: Check,
                },
            ],
        },
        {
            path: '*',
            name: '404',
            component: NotFound,
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    const { params = {}, query = {} } = from;
    console.log('to', to);
    console.log('from', from);
    if (from.name && from.name !== 'biz') {
        sendPV('CSC_COLLECT_PAGE', 'leave', {
            biz_key: params.bizKey || '',
            page_key: params.pageKey,
            from_key: query.from || -1,
        });
    }
    if ('production' !== process.env.NODE_ENV) {
        console.log(`[ROUTER]${from.path}=>${to.path}`);
    }
    const {
        params: {
            bizKey,
            pageKey,
        },
        name,
    } = to;
    const {
        getters,
    } = store;

    await store.dispatch('syncRouter', {
        bizKey,
        pageKey,
    });

    // 构建额外的查询参数字符串
    const buildExtraQueryStr = state => {
        const { originBizKey, soid, source, entranceId, gameId, appId, gameVersion } = state;
        console.log('[buildExtraQueryStr] state.useTitle:', state.useTitle);
        console.log('[buildExtraQueryStr] to.query.useTitle:', to.query.useTitle);
        let str = `&originBizKey=${originBizKey}&soid=${soid}&source=${source}&entranceId=${entranceId}`;
        const optionalParams = [
            { key: 'gameId', value: gameId },
            { key: 'appId', value: appId },
            { key: 'gameVersion', value: gameVersion },
        ];
        optionalParams.forEach(({ key, value }) => {
            if (value) {
                str += `&${key}=${value}`;
            }
        });
        // useTitle 不再拼接到 URL 中，直接从 store 读取即可
        return str;
    };

    const extraQueryStr = buildExtraQueryStr(store.state);
    console.log('[router] extraQueryStr:', extraQueryStr);
    if (ROUTER_NAME_BIZ === name) {
        console.log('1', ROUTER_NAME_BIZ);
        // 当前正在加载配置或者加载失败，允许进入
        if (!store.getters.isDone) {
            next();
            return;
        }

        // 配置已经加载完成，跳转当前应在页面
        next(`/biz/${bizKey}/page/${getters.nextPageKey || getters.headPageKey}?from=${store.state.from}${extraQueryStr}`);
        return;
    }

    if (ROUTER_NAME_PAGE === name) {
        console.log('2', ROUTER_NAME_PAGE);
        // 当前正在加载配置，允许进入
        if (!store.getters.isDone) {
            next();
            return;
        }

        // 配置已经加载完成，校验Page之间跳转
        if (-1 === getters.currentPageIndex || getters.currentPageIndex > getters.nextPageIndex) {
            // 越位，打回当前应在页面
            const targetUrl = `/biz/${bizKey}/page/${getters.nextPageKey || getters.headPageKey}?from=${store.state.from}${extraQueryStr}`;
            console.log('[router] ROUTER_NAME_PAGE targetUrl:', targetUrl);
            next(targetUrl);
            return;
        }
    }

    next();
});

// snakeCase会把-h5拆成H_5 算了还是自己写一个简易版的好了
// const convertToWeblogPageKey = (key = '') => {
//     return key.replace(/-/g, '_').toUpperCase();
// };

router.afterEach((to = {}) => {
    // 信息收集中台埋点的页面参数其实可以根据路由去生成
    const { name, params = {}, query = {} } = to;

    if (name === '404') {
        // sendPVOld({ page: 'COLLECT_NOT_FOUND_PAGE' });
        return;
    }
    if (name !== 'biz') {
        sendPV('CSC_COLLECT_PAGE', 'enter', {
            biz_key: params.bizKey || '',
            page_key: params.pageKey,
            from_key: query.from || -1,
        });
        customLog({
            type: customType.Pv,
            extra: {
                bizKey: params.bizKey || '',
            },
        });
    }
});

export default router;
